// @flow
import { connect } from 'react-redux'

import {
  setCurrentCompanyId,
  setCurrentOfficeId,
} from '@src/redux/modules/user/preferences'

const actions = {
  setCurrentCompanyId,
  setCurrentOfficeId,
}

export default connect(
  null,
  actions
)
